<template>
    <v-container class="pa-5" fluid>
        <ErrorReportingDialog
            :is-open="showErrorReportingDialog"
            @on-close="errorReportingDialogClosed"
            @on-submit="errorReportingDialogHandled"
        />
        <v-dialog
            :value="isOpen"
            max-width="1000px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Wybierz czynność
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <v-row>
                            <v-col v-for="(item, index) in reportProcesses" :key="index" cols="auto">
                                <div class="my-2">
                                    <v-btn
                                        color="grey"
                                        x-large
                                        dark
                                        rounded
                                        :class="{
                                            'button-size-80': item.isSelected || !item.isSelected,
                                            'success': item.isSelected,
                                        }"
                                        class="button-size-80"
                                        @click="updateProcessCode(item)"
                                    >
                                        {{ item.name }}
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        :disabled="actionLoading"
                        data-sentry-label="Anuluj"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        :loading="actionLoading"
                        data-sentry-label="Rozpocznij"
                        :disabled="!processCode"
                        @click="tryCreateReport"
                    >
                        Rozpocznij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CreateProcessReportDialog',
    components: {
        ErrorReportingDialog: () => import('./ErrorReportingDialog.vue')
    },
    props: {
        isOpen: {
            type: Boolean
        },
        reportProcessesData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            processCode: null,
            actionLoading: false,
            showErrorReportingDialog: false,
            reportProcesses: []
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        reportSettings() {
            return this.$store.state.reports.reporting.reportSettings
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.reportProcesses = JSON.parse(JSON.stringify(this.reportProcessesData))
                this.reportProcesses.map(process => process.isSelected = false)
            }
        }
    },
    methods: {
        updateProcessCode(item) {
            this.processCode = item

            this.reportProcesses.map(process => {
                if (process.id !== item.id) {
                    process.isSelected = false
                }
            })
            const index = this.reportProcesses.findIndex((process => process.id === item.id))

            this.reportProcesses.splice(index, 1, {...item, isSelected: true})
        },
        tryErrorReportingDialog() {
            this.showErrorReportingDialog = true
        },
        errorReportingDialogHandled(payload) {
            this.processCode.manualJobNumber = payload.jobNumber
            this.processCode.manualImpositionNumber = payload.impositionNumber
            this.createReport()
            this.errorReportingDialogClosed()
        },
        errorReportingDialogClosed() {
            this.showErrorReportingDialog = false
        },
        tryCreateReport() {
            const ERR_REPORTING_PROCESS_CODE = 10

            if (this.processCode.id !== ERR_REPORTING_PROCESS_CODE) {
                this.createReport()
            } else {
                this.tryErrorReportingDialog()
            }
        },
        createReport() {
            this.actionLoading = true

            let payload = {
                processCodeId: this.processCode.id,
                objectType: 3, // Inne zadanie
                objectId: this.processCode.id,
                objectNumber: '-',
                machine: this.reportSettings.machine.id,
                user: this.userId,
                currentlyReportedQuantity: 0,
                productionSiteId: this.reportSettings.workspace.id
            }

            if (this.processCode.manualJobNumber)
                payload.manualJobNumber = this.processCode.manualJobNumber
            if (this.processCode.manualImpositionNumber)
                payload.manualImpositionNumber = this.processCode.manualImpositionNumber

            this.$store.dispatch('reports/createReport', payload)
                .then(response => {
                    this.$router.push({
                        name: 'reportsReportingReport', //TODO: Sprawdzić czy działa
                        params: {
                            id: response.id,
                        }
                    })
                        .catch(error => {
                            errorHandler(error)
                        })
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.onClose()
                })
        },
        onClose() {
            this.actionLoading = false
            this.processCode = null
            this.$emit('on-close')
        }
    }
}
</script>